import React from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";
import { useSelector } from "react-redux";

const ConfirmationModal = ({
  isOpen,
  onClose,
  modalData,
  handleSubmit = () => {},
}) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);

  return (
    <Dialog size="xs" open={isOpen} handler={onClose}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Card className="w-full mx-auto ">
          <CardBody className="flex flex-col gap-4">
            <Typography variant="h4" color="blue-gray">
              {modalData.title}
            </Typography>
            <Typography
              className="mb-3 font-normal"
              variant="paragraph"
              color="gray"
            >
              {modalData.body}
            </Typography>
          </CardBody>
          <CardFooter className="flex justify-end gap-3 pt-0 ">
            <Button className="w-16 px-2 py-2 bg-red-800" onClick={onClose}>
              Close
            </Button>
            <Button
              style={{
                backgroundColor: selectedStore?.theme.backgroundColor,
              }}
              className="w-16 px-2 py-2 "
              type="submit"
            >
              {modalData.buttonText || "Login"}
            </Button>
          </CardFooter>
        </Card>
      </form>
    </Dialog>
  );
};

export default ConfirmationModal;
